export default __webpack_public_path__ + "static/media/all-nft-h-min.ccf3cde3.png";